// extracted by mini-css-extract-plugin
module.exports = {"margin-bottom5px":"style_margin-bottom5px__2TgQK","label-text":"style_label-text__1eWMd","error":"style_error__1XYjJ","required-field":"style_required-field__1yO1k"};